import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly browserTitle = inject(Title);
  private readonly translateService = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);
  private lastRouteTitleKey?: string;
  private currentTitle?: string;

  constructor() {
    super();

    this.translateService.onLangChange
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.updateTitleFromKey(this.lastRouteTitleKey));
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.lastRouteTitleKey = this.buildTitle(snapshot) ?? undefined;
    this.updateTitleFromKey(this.lastRouteTitleKey);
  }

  private updateTitleFromKey(routeTitleKey?: string): void {
    const translatedTitle = routeTitleKey
      ? this.translateService.instant(routeTitleKey)
      : undefined;
    const nextTitle =
      translatedTitle && translatedTitle !== routeTitleKey
        ? translatedTitle
        : this.getFallbackTitle();

    if (nextTitle === this.currentTitle) return;

    this.currentTitle = nextTitle;
    this.browserTitle.setTitle(nextTitle);
  }

  private getFallbackTitle(): string {
    const projectName = this.translateService.instant('projectName');
    return projectName && projectName !== 'projectName' ? projectName : 'GATE';
  }
}
